<template>
  <v-dialog
    :value="value"
    v-on:input="$emit('input', $event)"
    persistent
    :max-width="!confirm ? '600' : '350'"
  >
    <v-card v-show="!confirm">
      <v-card-title class="headline justify-center">
        <span>お知らせ作成</span>
      </v-card-title>
      <v-card-text class="mt-4">
        <!-- Title -->
        <label for="title">
          タイトル
          <span class="red--text">*</span>
        </label>
        <v-text-field
          dense
          outlined
          id="title"
          v-model="title"
          :error-messages="titleErrors"
          @input="$v.title.$touch()"
          @blur="$v.title.$touch()"
        ></v-text-field>
        <label for="title">
          内容
          <span class="red--text">*</span>
        </label>
        <v-textarea
          class="mt-2"
          dense
          outlined
          auto-grow
          v-model="content"
          :error-messages="contentErrors"
          @input="$v.content.$touch()"
          @blur="$v.content.$touch()"
        ></v-textarea>
        <v-row no-gutters>
          <v-spacer />
          <strong class=" mr-3" for="type">公開状態: </strong>
          <span class="">非公開</span>
          <!-- <v-select
            id="type"
            hide-details
            class="select-type"
            :items="typeList"
            v-model="type"
            dense
            item-text="text"
            item-value="type"
            outlined
          /> -->
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleHiddenDialog">キャンセル</v-btn>
        <v-btn
          color="primary"
          class="font-weight-bold"
          @click="handleHideShowConfirm"
          >決定</v-btn
        >
      </v-card-actions>
    </v-card>
    <!-- Dialog confirm -->
    <v-card v-show="confirm">
      <v-card-title class="headline justify-center">
        <span>確認</span>
      </v-card-title>
      <v-card-text class="pb-0"> 作成します。よろしいですか。 </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="font-weight-bold"
          :loading="loadingCreateNotification"
          @click="createNotification"
          small
          >OK</v-btn
        >
        <v-btn @click="handleHideShowConfirm" small>キャンセル</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import mixin from "@/mixin";

import { createNotification } from "@/api/MasterData.api";
export default {
  props: ["value", "data"],
  mixins: [mixin.ValidateNotification],
  data() {
    return {
      loadingCreateNotification: false,
      confirm: false,
      menuStartDate: false,
      title: "",
      content: "",
      type: "UNPUBLISH",
      typeList: [
        { type: "PUBLISH", text: "公開" },
        { type: "UNPUBLISH", text: "非公開" },
        // {type: "REMOVE",text: "取り下げ"},
      ],
    };
  },

  methods: {
    async createNotification() {
      const { title, content, type } = this;
      this.loadingCreateNotification = true;

      let params = {
        title,
        content,
        type,
      };
      await createNotification(params)
        .then(() => {
          this.$emit("resetList");
          this.$emit("input", false);
        })
        .catch(() => {});
      this.loadingCreateNotification = false;
    },
    handleHideShowConfirm() {
      this.$v.$touch();
      if (!this.$v.$anyError) {
        this.confirm = !this.confirm;
      }
    },
    handleHiddenDialog() {
      this.$v.$reset();
      this.$emit("input", false);
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  min-width: 130px;
  margin-top: 10px;
  font-weight: bold;
}
.select-type{
  max-width: 110px;
}
</style>